<template>
  <div class="advanced">
    <el-collapse v-model="activeNames" class="collapse-main-content">
      <el-collapse-item name="1">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>{{ this.$t('advanced.collapseTitle.operOrdertitle') }}
          </div>
        </template>
        <div class="collapse-content">
          <oper-order-table @row-change="rowChange" ref="operOrderTable" />
        </div>
      </el-collapse-item>
      <el-collapse-item v-show="eventOrderId" name="2">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>{{ this.$t('advanced.collapseTitle.orderPooltitle') }}
          </div>
        </template>
        <div class="collapse-content">
          <el-tabs @tab-click="orderTabClick" v-model="orderActiveTab" type="border-card">
            <el-tab-pane
              v-for="item in orderTabList"
              :key="item.name"
              :label="item.label"
              :name="item.name"
            >
              <order-pool-table :tabItem="item" ref="orderPoolTable" />
            </el-tab-pane>
          </el-tabs>
        </div>
      </el-collapse-item>
      <el-collapse-item v-show="eventOrderId" name="3">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>{{ this.$t('advanced.collapseTitle.interPooltitle') }}
          </div>
        </template>
        <div class="collapse-content">
          <el-tabs @tab-click="interTabClick" v-model="interActiveTab" type="border-card">
            <el-tab-pane
              v-for="item in interTabList"
              :key="item.name"
              :label="item.label"
              :name="item.name"
            >
              <inter-pool-table :tabItem="item" ref="interPoolTable" />
            </el-tab-pane>
          </el-tabs>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
  import operOrderTable from './components/operOrderTable'; // 计息事件-计息单据
  import orderPoolTable from './components/orderPoolTable'; // 单据池
  import interPoolTable from './components/interPoolTable'; // 计息池
  // import API from '@/api/capitalCenter/moneyDraw';

  export default {
    name: 'advanced',
    components: {
      operOrderTable,
      orderPoolTable,
      interPoolTable,
    },
    data() {
      return {
        activeNames: ['1', '2', '3'],
        orderActiveTab: 'cash',
        interActiveTab: 'cash',
        eventOrderId: null,
      };
    },
    computed: {
      tabList() {
        return [
          {
            name: 'cash',
            label: this.$t('advanced.tabTitle.cashtitle'),
            optionName: 'cashList',
          },
          {
            name: 'bill',
            label: this.$t('advanced.tabTitle.billtitle'),
            optionName: 'billList',
          },
          {
            name: 'CL',
            label: this.$t('advanced.tabTitle.CLtitle'),
            optionName: 'CLList',
          },
        ];
      },
      orderTabList() {
        return [
          ...this.tabList,
          {
            name: 'HN',
            label: this.$t('advanced.tabTitle.HNtitle'),
            optionName: 'HNList',
          },
        ];
      },
      interTabList() {
        return [
          ...this.tabList,
          {
            name: 'TF',
            label: this.$t('advanced.tabTitle.TFtitle'),
            optionName: 'TFList',
          },
        ];
      },
    },
    mounted() {},
    methods: {
      rowChange(val) {
        this.eventOrderId = val;
        this.orderActiveTab = this.interActiveTab = 'cash';
        this.$refs.orderPoolTable[0].getData(this.eventOrderId);
        this.$refs.interPoolTable[0].getData(this.eventOrderId);
      },
      orderTabClick(val) {
        this.orderTabList.map((item, idx) => {
          if (item.name == val.name) {
            this.$refs.orderPoolTable[idx].getData(this.eventOrderId);
          }
        });
      },
      interTabClick(val) {
        this.interTabList.map((item, idx) => {
          if (item.name == val.name) {
            this.$refs.interPoolTable[idx].getData(this.eventOrderId);
          }
        });
      },
    },
  };
</script>
